import { supabase } from './supabaseClient';

/**
 * Sign in with email and password
 */
export const signIn = async (email, password) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) throw error;
    return { success: true, user: data.user, session: data.session };
  } catch (error) {
    console.error('Sign in error:', error);
    return { success: false, error };
  }
};

/**
 * Sign out
 */
export const signOut = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Sign out error:', error);
    return { success: false, error };
  }
};

/**
 * Get current session
 */
export const getSession = async () => {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    return { success: true, session: data.session };
  } catch (error) {
    console.error('Get session error:', error);
    return { success: false, error };
  }
};

/**
 * Get current user
 */
export const getCurrentUser = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) throw error;
    return { success: true, user };
  } catch (error) {
    console.error('Get user error:', error);
    return { success: false, error };
  }
};

/**
 * Check if user is admin
 */
export const isAdmin = (user) => {
  if (!user) return false;
  // Check user metadata for admin role
  return user.user_metadata?.role === 'admin' || user.app_metadata?.role === 'admin';
};

/**
 * Check member subscription status from Supabase
 * Returns 'active', 'past_due', 'cancelled', or null if not found
 */
export const checkSubscriptionStatus = async (email) => {
  try {
    const { data, error } = await supabase
      .from('members')
      .select('subscription_status')
      .eq('email', email)
      .single();

    if (error || !data) return null;
    return data.subscription_status;
  } catch (error) {
    console.error('Error checking subscription status:', error);
    return null;
  }
};

/**
 * Subscribe to auth state changes
 */
export const onAuthStateChange = (callback) => {
  return supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session);
  });
};
